import { render, staticRenderFns } from "./EditInPlace.vue?vue&type=template&id=36412460&scoped=true"
import script from "./EditInPlace.vue?vue&type=script&lang=ts"
export * from "./EditInPlace.vue?vue&type=script&lang=ts"
import style0 from "./EditInPlace.vue?vue&type=style&index=0&id=36412460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36412460",
  null
  
)

export default component.exports